import { Constants, Enum } from '@examdojo/supabase';

export type UserProfession = Enum<'user_profession'>;

export const USER_PROFESSIONS = Constants.public.Enums.user_profession;
